// extracted by mini-css-extract-plugin
var _1 = "AccountContentContainer-module__animatedBackground--XevRJ";
var _2 = "AccountContentContainer-module__container--i2wJk";
var _3 = "AccountContentContainer-module__header--U3RNq";
var _4 = "AccountContentContainer-module__logo--nBQc_";
var _5 = "AccountContentContainer-module__main--cXcUa";
var _6 = "AccountContentContainer-module__subtitle--Vjzs8";
export { _1 as "animatedBackground", _2 as "container", _3 as "header", _4 as "logo", _5 as "main", _6 as "subtitle" }
